import "./Settings.css";
import Title from "./Title";
import Navbar from "./Navbar";
import SettingsSection from "./SettingsSection";
import { SETTING_GROUPS } from "./settingsConfig";

// Renders the groups and cards defined in settingsConfig.ts
function Settings() {
  return (
    <div className="settings">
      <Title title="Einstellungen ⚙️" />

      <div className="settings__content">
        {SETTING_GROUPS.map((group) => (
          <section key={group.title} className="settings__group">
            <h2 className="settings__groupTitle">{group.title}</h2>

            <div className="settings__cards">
              {group.cards.map((card) => (
                <SettingsSection
                  key={card.key}
                  settingKey={card.key}
                  icon={card.icon}
                  title={card.title}
                  description={card.description}
                  fields={card.fields}
                />
              ))}
            </div>
          </section>
        ))}
      </div>

      <Navbar />
    </div>
  );
}

export default Settings;
